import { ChevronRightIcon } from '@heroicons/react/24/outline'
import React from 'react'
import { Link, useParams } from 'react-router-dom'

const TechxplorationNavigation = () => {

    const { idEvent } = useParams();

    return (
        <div className=" flex p-2 mb-3 bg-slate-100">
            <div className='flex text-gray-500'> Tech'xploration  <ChevronRightIcon className="w-3 pt-2 ml-2 mr-5" /></div>
            <Link to={`/account/event/${idEvent}/techxploration`} className="mr-5">+ Nouvelle Tech'xploration</Link>
            <Link className="" to={`/account/event/${idEvent}/techxploration/my-techxplorations`}>Mes Tech'xploration</Link>
        </div>
    )
}

export default TechxplorationNavigation